import { applicationStore } from "src/store/ApplicationStore";
import React from "react";

import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
	const authToken = applicationStore.access_token;

	return authToken ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoutes;